var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AbstractButton } from './abstract-button';
import React from 'react';
import { IconArrowForward } from '@axafr-btc-ds/icons';
import { ColorHex, ColorSemanticHex } from '@axafr-btc-ds/colors';
import { buttonTheme } from './css/css';
var secondaryButtonProps = {
    bgColor: ColorHex.transparent,
    borderColor: ColorSemanticHex.principalDefault,
    fontColor: ColorSemanticHex.principalDefault,
    hoverBgColor: ColorSemanticHex.principalDefault,
    hoverBorderColor: ColorSemanticHex.principalDefault,
    hoverFontColor: ColorSemanticHex.neutral10,
    activeBgColor: ColorSemanticHex.principalDefault,
    activeBorderColor: ColorSemanticHex.principalDefault,
    activeFontColor: ColorSemanticHex.neutral10
};
var secondaryContrastButtonStyle = {
    bgColor: ColorHex.transparent,
    borderColor: ColorSemanticHex.neutral10,
    fontColor: ColorSemanticHex.neutral10,
    hoverBgColor: ColorSemanticHex.inverseHover,
    hoverBorderColor: ColorSemanticHex.inverseHover,
    hoverFontColor: ColorSemanticHex.primary40,
    activeBgColor: ColorSemanticHex.neutral50,
    activeBorderColor: ColorSemanticHex.primary40,
    activeFontColor: ColorSemanticHex.neutral10
};
export var SecondaryButton = React.forwardRef(function (_a, ref) {
    var isInversed = _a.isInversed, _b = _a.icon, Icon = _b === void 0 ? IconArrowForward : _b, props = __rest(_a, ["isInversed", "icon"]);
    return (React.createElement(AbstractButton, __assign({}, props, { ref: ref, icon: Icon, cssTheme: buttonTheme(isInversed
            ? secondaryContrastButtonStyle
            : secondaryButtonProps) })));
});
export default SecondaryButton;
